import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { APICallService } from 'src/app/services/api-call.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { SecurityService } from 'src/app/services/security.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { CustomValidators } from 'src/app/utils/custom-validator';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { LeaveConfirmation } from '../../common/guard/check.guard';
import { LineLovDialogComponent } from '../../common/line-lov-dialog/line-lov-dialog.component';
import { PlanLovComponent } from '../../common/plan-lov/plan-lov.component';
import { StateLovComponent } from '../../common/state-lov/state-lov.component';

@Component({
  selector: 'quotation-wordings-maintenance',
  templateUrl: './quotation-wordings-maintenance.component.html',
  styleUrls: ['./quotation-wordings-maintenance.component.css']
})
export class QuotationWordingsMaintenanceComponent implements OnInit, LeaveConfirmation {

  private moduleId: string = 'BMM179';
  public moduleName: string = this._jDS.data.moduleList.find((a: any) => a.moduleId === this.moduleId)?.moduleDesc ?? "";

  constructor(
    public _formService: FormService,
    private fb: FormBuilder,
    private _matDialog: MatDialog,
    private _api: APICallService,
    private _jDS: JsonDataService,
    private _userDetailService: UserDetailsService,
    private _securityService: SecurityService,
    private _appMessageService: AppMessageService,
    private jsonDataService: JsonDataService,
  ) {
    this.userIdLoggedIn = this._userDetailService.userId ?? "";
  }

  public canDeactivate(): boolean | Observable<boolean> {
    return !(this.quotationWordingsTblConfig.tblData?.filter((row: any) => ['I', 'U'].includes(row.operation)).length > 0);
  }

  ngOnInit(): void {
    this.checkSelects();
  }

  userTypeViewList: any = this.jsonDataService.data.refCds.filter((e: any) => e.rvDomain=="BMM013.USER_TYPE") || [];
  wordingTypeList: any = this.jsonDataService.data.refCds.filter((e: any) => e.rvDomain=="BMM179.WORDING_TYPE") || [];

  public btns = {
    quotationWordings: {
      updateDisabled: true,
      deleteDisabled: true,
      saveDisabled: true,
      addDisabled: false,
      formLovSearchDisabled: true
    },
    filterLov: {
      lineLovSearchDisabled: false,
      sublineLovSearchDisabled: true,
      planLovSearchDisabled: true,
    }
  };

  public showForm: boolean = true;

  //* Data Stuffs */
  private rowData: any;
  private errorMessage: string = "";
  private userIdLoggedIn: string;
  //? set selectedRow to [] to unselect the table
  public selectedRow!: any[];

  private tempDataFromGet: any[] = [];

  public forms = {
    filterLovForm: this.fb.group({
      lineCd: [null, [Validators.required]],
      lineName: [null],
      sublineCd: [null, [Validators.required]],
      userType: [null, [Validators.required]],
      wordingType: [null, [Validators.required]],
      sublineName: [null],
      planCd: [null, [Validators.required]],
      planName: [null],
      lineCdDisp: [{ value: '', disabled: 'true' }],
      sublineCdDisp: [{ value: '', disabled: 'true' }],
      planDisp: [{ value: '', disabled: 'true' }],
    }),
    quotationWordingsForm: this.fb.group({
      lineCd: [null, [Validators.required]],
      sublineCd: [null, [Validators.required]],
      planCd: [null, [Validators.required]],
      userType: [null, [Validators.required]],
      wordingType:[null, [Validators.required]],
      wordingCd: [null, [Validators.required, Validators.maxLength(4), this.checkDuplicateFloodZone(), CustomValidators.requiredTrim]],
      title: [null, [Validators.required, Validators.maxLength(100), CustomValidators.requiredTrim]],
      subtitle:[null, Validators.maxLength(100)],
      bulletNo:[null, Validators.maxLength(10)],
      seqNo:[null],
      wordings:[null, [Validators.required, CustomValidators.requiredTrim]],
      active: ['A', [Validators.required]],
      remarks: [null, [Validators.maxLength(1000)]],
      lastUpdateUser: [{ value: '', disabled: 'true' }],
      lastUpdate: [{ value: '', disabled: 'true' }],
    }),
    resetquotationWordingsForm: () => {
      this.forms.quotationWordingsForm.reset();
      this.forms.quotationWordingsForm.patchValue({
        active: 'A',
      });
      this.btns.quotationWordings.updateDisabled = this.btns.quotationWordings.deleteDisabled = true;
      this._formService.hideFormMsg("quotation-wordings-error-message");
      this.rowData = null;
      this.forms.quotationWordingsForm.get('wordingCd')?.enable();
    },
  };

  private quotationWordingsFormManipulate = {
    dbToForm: (data: any) => {
      return {
        lineCd: data.LINE_CD,
        sublineCd: data.SUBLINE_CD,
        planCd: data.PLAN_CD,
        userType: data.USER_TYPE,
        wordingType: data.WORDING_TYPE,
        wordingCd: data.WORDING_CD,
        title: data.TITLE,
        subtitle: data.SUB_TITLE,
        wordings: data.WORDINGS,
        bulletNo: data.BULLET_NO,
        seqNo: data.SEQ_NO,
        active: data.ACTIVE_TAG,
        remarks: data.REMARKS,
        lastUpdateUser: data.USER_ID,
        lastUpdate: data.LAST_UPDATE,
      };
    },
    formToDb: (data: any) => {
      return {
        LINE_CD: data.lineCd,
        SUBLINE_CD: data.sublineCd,
        PLAN_CD: data.planCd,
        USER_TYPE: data.userType,
        WORDING_TYPE: data.wordingType,
        WORDING_CD: data.wordingCd?.trim(),
        TITLE: data.title?.trim(),
        SUB_TITLE: data.subtitle,
        WORDINGS: data.wordings?.trim(),
        BULLET_NO: data.bulletNo,
        SEQ_NO: data.seqNo,
        ACTIVE_TAG: data.active,
        REMARKS: data.remarks,
        USER_ID: null,
        LAST_UPDATE: null,
      };
    },
  }

  public quotationWordingsTblConfig: any = {
    cols: [
      {
        key: "WORDING_CD",
        header: "Wording Code",
        dataType: "string",
        width: '144px',
      },
      {
        key: "TITLE",
        header: "Title",
        dataType: "string",
        width: '196px',
      },
      {
        key: "WORDINGS",
        header: "Wordings",
        dataType: "string",
      },
      {
        key: "SEQ_NO",
        header: "Seq. No.",
        dataType: "string",
        width: '128px',
      },
      {
        key: "ACTIVE_TAG",
        header: "A",
        dataType: "checkbox",
        width: '48px',
      }
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  }

  public openLov = {
    line: () => {
      const LOVOPTIONS: { [key: string]: any } = {
        disableClose: true,
        width: '512px',
        data: {
          table: 'LINE',
          moduleId: this.moduleId
        },
      }
      this._matDialog.open(LineLovDialogComponent, LOVOPTIONS).afterClosed().subscribe((dataOut: any) => {
        let output = dataOut.content;
        if (dataOut.button?.toUpperCase() === 'OK') {
          this.forms.resetquotationWordingsForm();
          if (output) {
            this.forms.filterLovForm.patchValue({
              lineCd: output.LINE_CD,
              lineName: output.LINE_NAME,
              lineCdDisp: `${output.LINE_CD} - ${output.LINE_NAME}`,
              sublineCd: null,
              sublineName: null,
              sublineCdDisp: null,
              planCd: null,
              planName: null,
              planDisp: null
            });
            this.btns.quotationWordings.addDisabled = true;
            this.btns.filterLov.sublineLovSearchDisabled = false;
            this.btns.filterLov.planLovSearchDisabled = true;
            this.checkSelects();
            if(this.checkSelects()){
              this.changeQuotationWordings();
            }
          }
          else {
            this.forms.filterLovForm.patchValue({
              lineCd: null,
              lineName: null,
              lineCdDisp: null,
              sublineCd: null,
              sublineName: null,
              sublineCdDisp: null,
              planCd: null,
              planName: null,
              planDisp: null,
            });
            this.checkSelects();
            this.btns.quotationWordings.addDisabled = this.btns.quotationWordings.formLovSearchDisabled = true;
            this.btns.filterLov.sublineLovSearchDisabled = true;
            this.btns.filterLov.planLovSearchDisabled = true;
          }
        }
      });
    },
    subline: () => {
      const LOVOPTIONS: { [key: string]: any } = {
        disableClose: true,
        width: '512px',
        data: {
          lineCd: this.forms.filterLovForm.get('lineCd')?.value,
          table: 'SUBLINE',
          moduleId: this.moduleId
        },
      }
      this._matDialog.open(LineLovDialogComponent, LOVOPTIONS).afterClosed().subscribe((dataOut: any) => {
        let output = dataOut.content;
        if (dataOut.button?.toUpperCase() === 'OK') {
          this.forms.resetquotationWordingsForm();
          if (output) {
            this.forms.filterLovForm.patchValue({
              lineCd: output.LINE_CD,
              lineName: output.LINE_NAME,
              lineCdDisp: `${output.LINE_CD} - ${output.LINE_NAME}`,
              sublineCd: output.SUBLINE_CD,
              sublineName: output.SUBLINE_NAME,
              sublineCdDisp: `${output.SUBLINE_CD} - ${output.SUBLINE_NAME}`,
              planCd: null,
              planName: null,
              planDisp: null,
            });
            this.checkSelects();
            if(this.checkSelects()){
              this.changeQuotationWordings();
            }
            this.btns.filterLov.planLovSearchDisabled = false;
          }
          else {
            this.forms.filterLovForm.patchValue({
              sublineCd: null,
              sublineName: null,
              sublineCdDisp: null,
              planCd: null,
              planName: null,
              planDisp: null,
            });
            this.checkSelects();
            this.btns.quotationWordings.addDisabled = this.btns.quotationWordings.formLovSearchDisabled = true;
            this.btns.filterLov.planLovSearchDisabled = true;
          }
        }
      });
    },
    plan: () => {
      const LOVOPTIONS: { [key: string]: any } = {
        disableClose: true,
        width: '512px',
        data: {
          table: 'PLAN',
          moduleId: this.moduleId,
          lineCd: this.forms.filterLovForm.get('lineCd')?.value,
          sublineCd: this.forms.filterLovForm.get('sublineCd')?.value,
          lpad: 2,
        },
      };
      this._matDialog.open(PlanLovComponent, LOVOPTIONS).afterClosed().subscribe((dataOut: any) => {
        let output = dataOut.content;
        if (dataOut.button?.toUpperCase() === 'OK') {
          if (output.PLAN_CD) {
            this.forms.filterLovForm.patchValue({
              planCd: output.PLAN_CD,
              planName: output.PLAN_NAME,
              planDisp: `${output.PLAN_CD} - ${output.PLAN_NAME}`,
            });
            this.checkSelects();
            if(this.checkSelects()){
              this.changeQuotationWordings();
            }
          }
          else {
            this.forms.filterLovForm.patchValue({
              planCd: null,
              planName: null,
              planDisp: null,
            });
            this.checkSelects();
            this.btns.quotationWordings.addDisabled = this.btns.quotationWordings.formLovSearchDisabled = true;
          }
        }
      });
    },
  }

  private getData = {
    quotationWordings: () => {
      try {
        this._jDS.contorlLoading(true);
        this._api.getQuotationWordings({
          moduleId: this.moduleId,
          userId: this._userDetailService.userId,
          type: "MODULE"
        }).subscribe({
          next: (response: any) => {
            this._securityService.checkRequestKeyResponse(response, () => {
              this._securityService.hasValidCsrfToken(response, () => {
                if (response.status === "SUCCESS") {
                  this.quotationWordingsTblConfig.tblData = [];
                  let content = JSON.parse(this._jDS.decrypt(response?.response));
                    content.data = content.data.filter((d: any) => (d.LINE_CD == this.forms.filterLovForm.get('lineCd')?.value 
                    && d.SUBLINE_CD == this.forms.filterLovForm.get('sublineCd')?.value 
                    && d.PLAN_CD == this.forms.filterLovForm.get('planCd')?.value 
                    && d.USER_TYPE == this.forms.filterLovForm.get('userType')?.value 
                    && d.WORDING_TYPE == this.forms.filterLovForm.get('wordingType')?.value));
                    this.quotationWordingsTblConfig.tblData = [...content.data];
                    this._jDS.contorlLoading(false);
                    this.quotationWordingsTblConfig.loading = false;
                }
                else {
                  this.quotationWordingsTblConfig.tblData = [];
                  this._jDS.contorlLoading(false);
                  this.quotationWordingsTblConfig.loading = false;
                }
              });
            });
          },
          error: (e: any) => {
            this._securityService.checkRequestKeyResponse(e, () => {

              this._jDS.contorlLoading(false);
              this.quotationWordingsTblConfig.loading = false;
            });
          }
        });
      }
      catch (e) {
    console.error(e);

      }
    }
  };

  public selections = {
    activeTypes: [
      { cd: 'A', name: 'Yes' },
      { cd: 'I', name: 'No' },
    ],
  };

  public onRowClick(ev: any) {
    try {
      if (ev) {
        this.rowData = ev;
        this.forms.quotationWordingsForm.get('wordingCd')?.disable();
        this.populateFormFromTable();
      }
      else {
        this.rowData = null;
        this.forms.resetquotationWordingsForm();
      }
    }
    catch (e) {
    console.error(e);
      this.rowData = null;
      this.forms.resetquotationWordingsForm();
    }
  }

  private populateFormFromTable() {
    try {
      let data = this.rowData;
      this.btns.quotationWordings.updateDisabled = false;
      this.btns.quotationWordings.deleteDisabled = !(this.rowData?.operation === 'I');
      this.forms.quotationWordingsForm.patchValue(this.quotationWordingsFormManipulate.dbToForm(data));
    }
    catch (e) {
    console.error(e);
    }
  }

  public onAdd(): void {
    try {
      this._formService.hideFormMsg("quotation-wordings-error-message");
      this.forms.quotationWordingsForm.patchValue({
        ...this.forms.filterLovForm.value
      });
      if (this.forms.quotationWordingsForm.valid) {
        let rowToBeAdded: { [key: string]: any } = this.quotationWordingsFormManipulate.formToDb(this.forms.quotationWordingsForm.getRawValue());
        rowToBeAdded.operation = 'I';
        this.quotationWordingsTblConfig.tblData = [rowToBeAdded, ...this.quotationWordingsTblConfig.tblData];
        this.forms.resetquotationWordingsForm();
        this.btns.quotationWordings.saveDisabled = false;
      }
      else {
        this.showErrorValidator.quotationWordings();
      }
    }
    catch (e) {
    console.error(e);

    }
  }

  public onUpdate(): void {
    try {
      this._formService.hideFormMsg("quotation-wordings-error-message");
      if (this.forms.quotationWordingsForm.valid) {
        const indexOfRow = this.quotationWordingsTblConfig.tblData.indexOf(this.rowData);
        let rowToBeUpdated: { [key: string]: any } = this.quotationWordingsFormManipulate.formToDb(this.forms.quotationWordingsForm.getRawValue());
        rowToBeUpdated.operation = (this.rowData.operation === 'I') ? 'I' : 'U';
        rowToBeUpdated.WORDING_CD = this.rowData?.WORDING_CD;
        this.forms.resetquotationWordingsForm();
        this.quotationWordingsTblConfig.tblData[indexOfRow] = rowToBeUpdated;
        this.selectedRow = [];
        this.btns.quotationWordings.saveDisabled = false;
        this.quotationWordingsTblConfig.tblData = [...this.quotationWordingsTblConfig.tblData];
      }
      else {
        this.showErrorValidator.quotationWordings();
      }
    }
    catch (e) {
    console.error(e);

    }
  }

  public onDelete(): void {
    try {
      this.quotationWordingsTblConfig.tblData = this.quotationWordingsTblConfig.tblData.filter((row: any) => {
        return row !== this.rowData;
      });
      this.forms.resetquotationWordingsForm();
      let toBeSaved = this.quotationWordingsTblConfig.tblData.filter((row: any) => ['I', 'U'].includes(row.operation));
      if (toBeSaved.length > 0) {
        this.btns.quotationWordings.saveDisabled = false;
      }
      else{
        this.btns.quotationWordings.saveDisabled = true;
      }
    }
    catch (e) {
    console.error(e);

    }
  }

  public onSave(): void {
    try {
      this.showForm = false;
      this._formService.showFormLoader(null, "quotation-wordings-maintenance-loading", "Saving.<br>Please wait ...", null, null, false);
      let toBeSaved = this.quotationWordingsTblConfig.tblData.filter((row: any) => ['I', 'U'].includes(row.operation));
      if (toBeSaved.length > 0) {
        this._api.saveQuotationWordings(toBeSaved).subscribe({
          next: (response: any) => {
            this._securityService.checkRequestKeyResponse(response, () => {
              this._securityService.hasValidCsrfToken(response, () => {
                if (response.status === 'SUCCESS') {
                  this.onComplete.quotationWordings();
                }
                else {
                  this.onComplete.quotationWordingsError();
                }
              });
            });
          },
          error: (data: any) => {
            this._securityService.checkRequestKeyResponse(data, () => {

              this.onComplete.quotationWordingsError();
            });
          }
        });
      }
      else {
        this.onComplete.quotationWordings();
      }
    }
    catch (e) {
    console.error(e);

    }
  }

  private onComplete = {
    quotationWordings: () => {
      this._jDS.contorlLoading(false);
      this._formService.hideFormLoader("quotation-wordings-maintenance-loading");
      this.openDialog('SUCCESS', this.moduleName.replace('Maintenance', ''), 'saved');
      this.btns.quotationWordings.saveDisabled = true;
      this.showForm = true;
      this.forms.resetquotationWordingsForm();
    },
    quotationWordingsError: () => {
      this._jDS.contorlLoading(false);
      this.openDialog('FAILED', this.moduleName.replace('Maintenance', ''), 'saving');
      this._formService.hideFormLoader("quotation-wordings-maintenance-loading");
      this.showForm = true;
      this.forms.resetquotationWordingsForm();
    },
  }

  private openDialog(title: string, contentTitle: string, contentDetail: string) {
    try {
      this._matDialog.open(DialogMsgComponent, {
        disableClose: true,
        width: '512px',
        data: {
          title: title,
          content:
            title === 'SUCCESS'
              ? `${contentTitle} details successfully ${contentDetail}!`
              : `${contentTitle} details ${contentDetail} failed!`,
        },
      }).afterClosed().subscribe(() => {
        if (title === 'SUCCESS') {
          this.getData.quotationWordings();
        }
      });
    }
    catch (e) {
    console.error(e);

    }
  }

  //* Validator Stuffs Down here */

  private checkDuplicateFloodZone(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.trim()?.toUpperCase();
      if (!value) return null;
      let hasDuplicate: boolean = this.quotationWordingsTblConfig?.tblData.filter((d: any) => {
        if (!this.rowData)
          return d['WORDING_CD']?.trim().toUpperCase() === value;
        else
          return this.rowData['WORDING_CD']?.trim()?.toUpperCase() !== value && d['WORDING_CD']?.trim()?.toUpperCase() === value;
      }).length > 0 ? true : false;
      return hasDuplicate ? { hasDupe: true } : null;
    }
  }

  private checkDuplicateFloodShortDesc(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value?.trim()?.toUpperCase();
      if (!value) return null;
      let hasDuplicate: boolean = this.quotationWordingsTblConfig?.tblData.filter((d: any) => {
        if (!this.rowData)
          return d['FLOOD_SHORT_DESC']?.trim().toUpperCase() === value;
        else
          return this.rowData['FLOOD_SHORT_DESC']?.trim()?.toUpperCase() !== value && d['FLOOD_SHORT_DESC']?.trim()?.toUpperCase() === value;
      }).length > 0 ? true : false;
      return hasDuplicate ? { hasDupe: true } : null;
    }
  }

  public showErrorValidator = {
    quotationWordings: () => {
      try {
        Object.keys(this.forms.quotationWordingsForm.controls).forEach(key => {
          const controlErrors = this.forms.quotationWordingsForm.get(key)?.errors;
          if (controlErrors != null) {
            Object.keys(controlErrors).forEach(keyError => {
              if (keyError == 'hasDupe' && controlErrors[keyError] === true && key === 'wordingCd')
                this.errorMessage = "Wording Code already exists. Please add a unique Wording Code";
              else if (keyError == 'hasDupe' && controlErrors[keyError] === true && key === 'floodShortDesc')
                this.errorMessage = "Wording Short Description already exists. Please use a unique Wording Short Description.";
              else if (keyError == 'required' && controlErrors[keyError] === true)
                this.errorMessage = "There are missing information. Please provide necessary information needed.";
            });
          }
        });
        this._formService.showFormMsg("quotation-wordings-error-message", this.errorMessage, "E");
      }
      catch (e) {
    console.error(e);

      }
    },
  }


  numOnlyPattern(ev: any) {
    try{
      const pattern = /^[0-9]\d*$/;
      if (!pattern.test(ev.target.value)) {
        ev.target.value = ev.target.value.replace(/[^0-9]/g, "");
      }
    }
    catch(e) {

    }
  }

  checkSelects(){
    this.forms.resetquotationWordingsForm();
    if (this.forms.filterLovForm.get('lineCd')?.value
    && this.forms.filterLovForm.get('sublineCd')?.value
    && this.forms.filterLovForm.get('planCd')?.value) {
      this.forms.filterLovForm.get('userType')?.enable();
    }
    else{
      this.forms.filterLovForm.patchValue({
        userType: null
      });
      this.forms.filterLovForm.get('userType')?.disable();
    }
    if(this.forms.filterLovForm.get('lineCd')?.value
    && this.forms.filterLovForm.get('sublineCd')?.value
    && this.forms.filterLovForm.get('planCd')?.value
    && this.forms.filterLovForm.get('userType')?.value){
      this.forms.filterLovForm.get('wordingType')?.enable();
      return true;
    }
    else{
      this.forms.filterLovForm.patchValue({
        wordingType: null
      });
      this.forms.filterLovForm.get('wordingType')?.disable();
      return false;
    }
  }
  changeQuotationWordings(){
    if (this.forms.filterLovForm.valid) {
        this.quotationWordingsTblConfig.tblData = [];
        this.forms.resetquotationWordingsForm();
        this.btns.quotationWordings.addDisabled = false;
        this.btns.quotationWordings.saveDisabled = true;
        this.getData.quotationWordings();
      }
    else {
      this.btns.quotationWordings.addDisabled = true;
    }
  }
}
